<template>
    <div class='headerSerc'>
        <tab @getTab="getTab"></tab>
        <div id='content' v-show="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.menuConfig.title}}</span>
                <menusConfig :setTingObj="setTingObj"></menusConfig>
            </div>
        </div>
        <div id='style' v-show="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
                <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class="headerSerc-item">
                <span>{{setTingObj.bgColorImg.title}}</span>
                <bgColorImg :bgColorImg="setTingObj.bgColorImg"></bgColorImg>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.height.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.height"></sliderAndInput>
            </div>
            <div class='headerSerc-item' v-if="setTingObj.lrConfig">
                <span>{{setTingObj.lrConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.lrConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.lrEdge.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.lrEdge"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue'
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import radio from '@/components/decoration/common/radio.vue';
import menusConfig from '@/components/decoration/common/menusConfig.vue';
import bgColorImg from '@/components/decoration/common/bgColorImg.vue';

export default {
    components: {
        bgColorImg,
        menusConfig,
        radio,
        sliderAndInput,
        tab,
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            status: 'content'
        };
    },
    methods: {
        getTab(e) {
            this.status = e
        },
        updateBgStyle(type){
            this.setTingObj.bgStyle.type = type
        },
    }
};
</script>

<style lang='scss' scoped>

</style>